import {PhoneNumberUtil} from 'google-libphonenumber';
import {grok as validateIMSI} from 'imsi-grok';


export function validMSISDN (msisdn: string, countryCode: string): boolean {
  const phonenumbers = new PhoneNumberUtil();
  let number;

  if (phonenumbers.isAlphaNumber(msisdn)) {
    return false;
  }

  try {
    number = phonenumbers.parseAndKeepRawInput(msisdn, countryCode);
  } catch {
    return false;
  }

  return (
    phonenumbers.isValidNumber(number) &&
    phonenumbers.isValidNumberForRegion(number, countryCode)
  );
}

export function validIMSI (imsi: string): boolean {
  try {
    return !!validateIMSI(imsi);
  } catch {
    return false;
  }
}
